import { Profile } from '../../../scripts/api/models/user';

export default class UserList {
    private _users: Profile[] = [];

    public constructor (public readonly userCount: number) {}

    public set users (users: Profile[]) {
        users = users.sort((a, b) => a.displayName.localeCompare(b.displayName, 'de'));
        this._users = users;
    }

    public get users (): Profile[] {
        return this._users;
    }

    public get initialized (): boolean {
        return this._users.length > 0;
    }
}
